import { render, staticRenderFns } from "./_Attachments.vue?vue&type=template&id=68d5a3eb"
import script from "./_Attachments.vue?vue&type=script&lang=js"
export * from "./_Attachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports